// This file contains the feature flags for the Nebula app.
// The flags are set using environment variables and can be changed based on the environment (development, production, etc.)
// The flags are used in the code to conditionally render components or enable/disable features.
export const patientEngagementFlowFeatureFlagEnabled =
	import.meta.env.VITE_PATIENT_ENGAGEMENT_FLOW_FEATURE_FLAG === 'true';

export const patientAssignmentFeatureFlagEnabled =
	import.meta.env.VITE_PATIENT_ASSIGNMENT_FEATURE_FLAG === 'true';
